import { render } from "./SupplierPriceChangesDialog.vue?vue&type=template&id=d2a323ec"
import script from "./SupplierPriceChangesDialog.vue?vue&type=script&lang=js"
export * from "./SupplierPriceChangesDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__